export default function checkHasVhBug() {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera
  const lowerCaseUserAgent = userAgent.toLowerCase()
  if (!userAgent) return false

  const isAndroid = /android/.test(lowerCaseUserAgent)
  const isIos = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)

  let regexp
  if (isAndroid) {
    regexp = /messenger|instagram|snapchat|nrk|firefox|opera|klar\//
  } else if (isIos) {
    regexp = /messenger|instagram|snapchat|nrk|firefox|opera|chrome|fxios|crios/
  }

  return regexp && regexp.test(lowerCaseUserAgent)
}
